import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import SimpleRoundedButton from 'components/basic/Button/SimpleRoundedButton';
import { trackEvent } from 'lib/analytics';
import { stopPendingSignatureRequest } from 'lib/ethereum/sign/utils';
import { unlockWalletConnect } from 'lib/ethereum/wallets/walletConnectV2';
import { closeSignatureInfoModal } from 'reduxState/exchange/exchangeSignatureModal';
import { staticDispatch, useSelector } from 'reduxState/store';

const Wrapper = styled.div`
  margin-top: 20px;
  text-align: center;
`;

/**
 * Reconnect wallet after few seconds when it's stuck on signature of text or hash.
 * Note: For deposit/transfer signature we cannot cancel existing signature if it's submitted by wallet itself
 */
export default function ReconnectWalletButton({
  onReconnect,
}: {
  onReconnect?: (message: string) => void;
}) {
  const walletType = useSelector(state => state.wallet.walletType);
  const [enabled, setEnabled] = useState(false);

  // WalletConnect is only wallet which is not very responsive
  const reconnectSupported = walletType === 'walletConnect';

  useEffect(() => {
    // Display Reconnect after short delay
    if (!reconnectSupported) {
      return;
    }
    const timeout = setTimeout(() => {
      setEnabled(true);
    }, 6000);
    return () => {
      clearTimeout(timeout);
    };
  }, [reconnectSupported]);

  if (!enabled) {
    return null;
  }

  if (!reconnectSupported) {
    return null;
  }

  const handleReconnect = () => {
    setEnabled(false);
    stopPendingSignatureRequest();
    staticDispatch(closeSignatureInfoModal());
    if (onReconnect) {
      onReconnect('Action canceled');
    }
    if (walletType === 'walletConnect') {
      trackEvent('wallet_reconnect_walletConnect');
      unlockWalletConnect();
    }
  };

  return (
    <Wrapper>
      <SimpleRoundedButton onClick={handleReconnect}>
        Cancel request and Reconnect wallet
      </SimpleRoundedButton>
    </Wrapper>
  );
}
